import './PodiumView.scss';

import { EmojiEvents } from '@mui/icons-material';
import { Hidden } from '@mui/material';
import { ClassementParticipant } from 'domain/classement/ClassementParticipant';
import { EventStatusEnum } from 'domain/event/EventStatusEnum';
import { PlayerTeam } from 'domain/event/PlayerTeam';
import { UnpyEvent } from 'domain/event/UnpyEvent';
import { UnpyEventView } from 'domain/event/UnpyEventView';
import { LoadingScreen } from 'primary/Components/LoadingScreen/LoadingScreen';
import { TagPlayer } from 'primary/Components/TagPlayer/TagPlayer';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useRetrieveFromDomain } from 'primary/hooks/useRetrieveFromDomain';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';

interface PodiumViewProps {
  event: UnpyEventView | UnpyEvent;
}

export const IconPodiumByIndex = [
  <EmojiEvents className={'-podium--first'} key={'-podium--first'} />,
  <EmojiEvents className={'-podium--second'} key={'-podium--second'} />,
  <EmojiEvents className={'-podium--third'} key={'-podium--third'} />,
];

export const IconPodiumByIndexBR = [
  <EmojiEvents className={'-podium--first'} key={'-podium--first'} />,
  <EmojiEvents className={'-podium--second'} key={'-podium--second'} />,
  <EmojiEvents className={'-podium--second'} key={'-podium--second'} />,
  <EmojiEvents className={'-podium--third'} key={'-podium--third'} />,
];

type PodiumItemProps = {
  classementParticipant?: ClassementParticipant;
  place: number;
};

const PodiumItem = ({ classementParticipant, place }: PodiumItemProps) => {
  const t = useTranslate();
  return (
    <div className={'-podium--item'} key={0}>
      <div>{IconPodiumByIndex[place]}</div>
      {classementParticipant && (
        <div>
          <span className={'-nameTeam'}>
            {classementParticipant.participant?.team.name}
          </span>
          <div className={'-playersTeam'}>
            {classementParticipant.participant?.team.players.map((player: PlayerTeam) => (
              <TagPlayer embed key={player?.player?.idPlayer} player={player.player} />
            ))}
          </div>
        </div>
      )}
      {!classementParticipant && (
        <span className={'-nameTeam'}>{t('event.podium.noContentParticipant')}</span>
      )}
    </div>
  );
};

export const PodiumView = ({ event }: PodiumViewProps) => {
  const t = useTranslate();
  const { classementRepository } = useContextDependency();
  const [classementParticipants, , fetching] = useRetrieveFromDomain(
    () => classementRepository.getPodium(event.id),
    undefined,
  );
  const sorted = classementParticipants?.sort(
    (p, p2) => (p2.score ?? 0) - (p.score ?? 0),
  );

  return (
    <div className={'podiumView'}>
      {fetching && <LoadingScreen loading />}
      {!fetching && (
        <>
          <div className={'-title'}>
            {event.status === EventStatusEnum.FINISH && (
              <h2>
                {t('event.podium.title')}
                <span>{event.name}</span>
              </h2>
            )}
            {event.status !== EventStatusEnum.FINISH && (
              <h2>
                {t('event.podium.noFinishTitle')} <span>{event.name}</span>
              </h2>
            )}
          </div>
          <div className={'-podium'}>
            <Hidden smUp>
              <PodiumItem key={0} classementParticipant={sorted?.[0]} place={0} />
              <PodiumItem key={1} classementParticipant={sorted?.[1]} place={1} />
              <PodiumItem key={2} classementParticipant={sorted?.[2]} place={2} />
            </Hidden>
            <Hidden smDown>
              <PodiumItem key={2} classementParticipant={sorted?.[2]} place={2} />
              <PodiumItem key={0} classementParticipant={sorted?.[0]} place={0} />
              <PodiumItem key={1} classementParticipant={sorted?.[1]} place={1} />
            </Hidden>
          </div>
        </>
      )}
    </div>
  );
};
